import React from 'react';
import ReactDOM from 'react-dom/client';

import { ThemeProvider, createTheme } from '@mui/material/styles';
import App from './App.tsx';
import './styles/Global.scss';

// THEME
const darkTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: { main: '#00cebb' },
        background: { default: '#0b1018', paper: '#151d29' }
    },
    typography: {
        fontFamily: "'Public Sans', sans-serif"
    }
});

// CREATE ROOT
ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <ThemeProvider theme={darkTheme}>
            <App />
        </ThemeProvider>
    </React.StrictMode>
)
